/**
 * Centralized translations for Service Screen module
 * Contains all labels used across service screen components
 */

export const ServiceScreenLabels = {
    it: {
        logoutSuccessful: "LOGOUT EFFETTUATO CORRETTAMENTE",
        loginError: "Abbiamo avuto un problema durante il login, riprova di nuovo",
        login: "LOGIN",
        logoutSSO:'SSO LOGOUT',
        retry:'Riprova'
    },
    
    en: {
        logoutSuccessful: "LOGOUT COMPLETED SUCCESSFULLY",
        loginError: "We encountered a problem during login, please try again", 
        login: "LOGIN",
        logoutSSO:'SSO LOGOUT',
        retry:'Try Again'

    }
}; 